import EstimateCard from "./EstimateCard";
import ToolLossCard from "./ToolLossCard";
import { useAuth } from "../../context/AuthContext";

const EquipmentTab = ({
  job,
  canManageJobs,
  onSaveEquipmentEstimates,
  onPopulateFromBidSheet,
  hasBidSheet = false,
  getAuthHeaders,
  onJobUpdate,
}) => {
  const { user } = useAuth();
  const canManageLosses = user?.role === "admin" || user?.role === "office_manager";

  return (
    <div className="space-y-6" data-testid="equipment-tab">
      <EstimateCard
        title="Equipment Estimates"
        estimates={job.equipment_estimates || []}
        totalEstimate={job.total_equipment_estimate || 0}
        canManage={canManageJobs}
        onSave={onSaveEquipmentEstimates}
        nameField="equipment_name"
        testIdPrefix="equipment"
        onPopulateFromBidSheet={onPopulateFromBidSheet}
        hasBidSheet={hasBidSheet}
      />
      {canManageLosses && getAuthHeaders && (
        <ToolLossCard
          job={job}
          getAuthHeaders={getAuthHeaders}
          onJobUpdate={onJobUpdate}
        />
      )}
    </div>
  );
};

export default EquipmentTab;
